import { TaskRef } from '@/tracker/types';

/** Родитель из ?parent=KEY; название приходит в state ссылки из карточки, по прямой ссылке — только ключ */
export const getInitialParent = ({
  key,
  state,
}: {
  key: string | null;
  state: unknown;
}): TaskRef | null => {
  if (!key) return null;

  const parent = (state as { parent?: TaskRef } | null)?.parent;

  return parent?.key === key ? parent : { key, summary: '' };
};
